<template>
  <v-flex xs12 :class="padding ? 'px-3' : 'px-0'" style="padding-top: 10px !important; width: 100vw;">
    <v-flex xs12 v-if="showBreadCrumb">
      <div style="display: inline-block; width: 100%;">
        <v-btn @click="gotoFrontPage" style="width: 50px;" class="breadCrumb" v-if="showBreadCrumb">
          <v-icon>home</v-icon>
        </v-btn>
        <v-btn @click="deSelectMode" class="breadCrumb breadCrumbWide" v-if="showBreadCrumb">
          Production report
        </v-btn>
        <v-btn @click="goShipments" class="breadCrumb breadCrumbWide" v-if="false && (showBreadCrumb && inShipments)">
          Production overview
        </v-btn>
        <v-btn @click="goShipmentsForLoader" class="breadCrumb breadCrumbWide" v-if="showBreadCrumb && inShipmentsForLoader">
          Loading overview
        </v-btn>
        <v-btn @click="sortByDate" class="breadCrumb breadCrumbWide" v-if="showBreadCrumb && sortedByDate">
          Daily production
        </v-btn>
        <v-btn @click="sortByField" class="breadCrumb breadCrumbWide" v-if="showBreadCrumb && sortedByField">
          Field status
        </v-btn>
        <v-btn @click="productionSummary" class="breadCrumb breadCrumbWide" v-if="showBreadCrumb && inProductionSummary">
          Production summary
        </v-btn>
        <v-btn @click="goDeliveredShipments" class="breadCrumb breadCrumbWide" v-if="showBreadCrumb && inDeliveredShipments">
          Delivered shipments
        </v-btn>

        <div style="display: inline; float: right;">
          <v-btn @click="toggleFilterProduced(false)" class="btnPlannedReport" :style="buttonStyleFilterPlanned" :disabled="!produced" v-if="isModeSelected && !inShipments && !inShipmentsForLoader && !inProductionSummary && !inDeliveredShipments">
            Planned
          </v-btn>
          <v-btn @click="toggleFilterProduced(true)" class="btnProducedReport" :style="buttonStyleFilterProduced" :disabled="produced" v-if="isModeSelected && !inShipments && !inShipmentsForLoader && !inProductionSummary && !inDeliveredShipments" style="margin-right: 50px;">
            Produced
          </v-btn>
          <v-btn @click="excelReport" class="btnPrintReport" style="margin-left: 2px !important; float: right;" v-if="showExcelButton && isModeSelected && !inShipments && !inShipmentsForLoader && !inProductionSummary && !inDeliveredShipments">
            Excel
          </v-btn>
          <v-btn @click="printReport" class="btnPrintReport" style="margin-left: 50px !important; float: right;" :disabled="inDeliveredShipments && !chosenShipment" v-if="showPdfButton && isModeSelected && !inShipments && !inShipmentsForLoader && !inProductionSummary">
            Print
          </v-btn>
          <v-btn @click="excelShipments()" class="btnPrintReport" style="margin-left: 2px !important; float: right;" :disabled="!canPrintShipments" v-if="showExcelButton && isModeSelected && inShipments && shipments && shipments.length > 0" :key="printShipmentsUpdateCounter + 'pdf'">
            Excel
          </v-btn>
          <v-btn @click="excelShipments(true)" class="btnPrintReport" style="margin-left: 2px !important; float: right;" :disabled="!canPrintShipments" v-if="showExcelButton && isModeSelected && inShipmentsForLoader && shipments && shipments.length > 0" :key="printShipmentsUpdateCounter + 'forLoader_pdf'">
            Excel
          </v-btn>
          <v-btn @click="printShipments()" class="btnPrintReport" style="margin-left: 50px !important; float: right;" :disabled="!canPrintShipments" v-if="showPdfButton && isModeSelected && inShipments && shipments && shipments.length > 0" :key="printShipmentsUpdateCounter + 'excel'">
            Print
          </v-btn>
          <v-btn @click="printShipments(true)" class="btnPrintReport" style="margin-left: 50px !important; float: right;" :disabled="!canPrintShipments" v-if="showPdfButton && isModeSelected && inShipmentsForLoader && shipments && shipments.length > 0" :key="printShipmentsUpdateCounter + 'forLoader_excel'">
            Print
          </v-btn>
        </div>
        <div style="height: 10px;"></div>
      </div>
    </v-flex>
    <v-flex xs12 v-if="!isModeSelected">
      <v-flex style="width: 50%; position: absolute; top: 50%; left: 50%; transform: translateY(-50%) translateX(-50%);">
        <v-btn v-if="false && (hasContractorRole || hasSupplierRole)" @click="goShipments" :style="'width: 100%; height: 10vh !important; font-size: 16pt !important; margin-bottom: 2vh !important;'">Production overview</v-btn>
        <v-btn v-if="hasContractorRole || hasSupplierRole" @click="goShipmentsForLoader" :style="'width: 100%; height: 10vh !important; font-size: 16pt !important; margin-bottom: 2vh !important;'">Loading overview</v-btn>
        <v-btn v-if="hasContractorRole" @click="sortByDate" :style="'width: 100%; height: 10vh !important; font-size: 16pt !important; margin-bottom: 2vh !important;'">Daily production</v-btn>
        <v-btn v-if="hasContractorRole" @click="sortByField" :style="'width: 100%; height: 10vh !important; font-size: 16pt !important; margin-bottom: 2vh !important;'">Field status</v-btn>
        <v-btn v-if="hasContractorRole" @click="productionSummary" :style="'width: 100%; height: 10vh !important; font-size: 16pt !important; margin-bottom: 2vh !important;'">Production summary</v-btn>
        <v-btn v-if="hasContractorRole" @click="goDeliveredShipments" :style="'width: 100%; height: 10vh !important; font-size: 16pt !important;'">Delivered shipments</v-btn>
      </v-flex>
    </v-flex>
    <v-container fluid :class="padding ? 'py-2 px-3' : 'py-0 px-3'"  v-if="isModeSelected && productionReportLoaded">
      <v-layout style="max-height: calc(100vh - 180px);">
        <v-flex style="overflow-y: auto;">
          <v-container fluid pa-0 v-if="inShipments || inShipmentsForLoader">
            <v-layout wrap>
              <v-flex text-xs-left xs12 md2 px-2>
                <v-text-field v-model="searchShipments" append-icon="search" placeholder="Search" style="padding-bottom: 0 !important;"/>
              </v-flex>
              <v-flex text-xs-left xs12 md3 px-2 style="padding-top: 6px;">
                <v-select :items="filterSuppliers" v-model="filterSupplier" item-text="name" prepend-icon="a-factory" return-object @change="loadShipments()" class="supplierFilter"/>
              </v-flex>
              <v-flex text-xs-left xs12 md3 px-2 style="padding-top: 6px;">
                <v-select :items="filterFields" v-model="filterField" item-text="address.nameAndText" prepend-icon="a-address" return-object @change="loadShipments()" class="fieldFilter"/>
              </v-flex>
              <v-flex text-xs-left xs12 md4 px-3 style="padding-top: 6px;">
                <v-autocomplete :items="filterCategories" v-model="filterCategory" item-text="displayLabel" prepend-icon="a-trees" return-object @change="loadShipments()" class="categoryFilter">
                  <template slot="selection" slot-scope="data">
                    <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                    <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                    {{ data.item.displayLabel }}
                  </template>
                  <template slot="item" slot-scope="data">
                    <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                    <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                    {{ data.item.displayLabel }}
                  </template>
                </v-autocomplete>
              </v-flex>

              <v-flex text-xs-left xs12 class="productionReport">
                <v-data-table :headers="inShipmentsForLoader ? shipmentHeadersForLoader : shipmentHeaders" :items="shipments" v-model="filteredShipments" :search="searchShipments" ref="shipments" hide-actions class="shipmentTable" v-show="shipments && shipments.length > 0">
                  <template v-slot:items="props">
                    <tr>
                      <td class="text-xs-left shipmentNo" style="padding-top: 1px !important;">{{ props.item.number }}</td>
                      <td class="text-xs-left nowrap"><div v-html="props.item.pickupAddresses"></div></td>
                      <td class="text-xs-left nowrap"><div v-html="props.item.suppliers"></div></td>
                      <td class="text-xs-left nowrap"><div v-html="props.item.fields"></div></td>
                      <td class="text-xs-left nowrap" style="padding-bottom: 1px !important; padding-right: 0 !important;"><div v-html="props.item.categories"></div></td>
                      <td class="text-xs-right nowrap ml_pallets" style="padding-left: 0 !important;"><div v-html="displayNumberOfPallets(props.item.numberOfPallets)"></div></td>
                      <td class="text-xs-right nowrap" style="padding-left: 0 !important; padding-right: 20px !important;"><div v-html="props.item.piecesPerPallet"></div></td>
                      <td class="text-xs-center nowrap" style="width: 70px; padding-left: 20px !important; padding-right: 5px !important;"><div v-html="props.item.status"></div></td>
                      <td class="text-xs-right nowrap" style="max-width: 80px; padding-right: 5px !important;"><div v-html="props.item.total"></div></td>
                      <td class="text-xs-left" style="padding-top: 1px !important;">{{ displayDate(props.item.contractorDate) }}</td>
                      <td class="text-xs-left" style="padding-top: 1px !important;" v-if="inShipmentsForLoader">{{ displayDate(props.item.pickupDate) }}</td>
                      <td class="text-xs-left" style="padding-top: 1px !important;">{{ props.item.carrierName }}</td>
                      <td class="text-xs-left" style="padding-top: 1px !important;"><div v-html="props.item.comments" style="white-space: nowrap;"></div></td>
                    </tr>
                  </template>
                </v-data-table>
                <div class="noShipments" v-if="!(shipments && shipments.length > 0)">No shipments found</div>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container fluid pa-0 v-if="sortByDate && produced" style="margin-bottom: 12px;">
            <v-layout wrap>
              <v-flex text-xs-left xs12 md3 px-2 style="padding-top: 6px;">
                <v-select :items="producedByUsers" v-model="filterProducedBy" item-text="name" item-value="name" prepend-icon="person" @change="sortByDate()" class="producedByFilter"/>
              </v-flex>
            </v-layout>
          </v-container>
          <table class="productionReport" v-if="sortedByField">
            <tr>
              <th>Supplier</th>
              <th>Field</th>
              <th>Category</th>
              <th v-if="!produced">Deadline</th>
              <th style="text-align: right; padding-right: 10px; width: 100px;">Pallets</th>
              <th style="text-align: right; padding-right: 10px; width: 100px;">Amount</th>
              <th v-if="produced" style="text-align: right; padding-right: 10px; width: 100px;">Labelled</th>
              <th v-if="produced" style="text-align: right; padding-right: 10px; width: 100px;">Progress</th>
            </tr>
            <template v-for="(supplierReport) in productionReport.suppliers">
              <template v-for="(fieldReport) in supplierReport.fields">
                <tr v-bind:key="fieldReport.field.id" :class="(fieldReport.rowIndex % 2 === 0 ? 'even' : 'odd')">
                  <td class="main">
                    {{ supplierReport.supplier.name }}
                  </td>
                  <td class="main">
                    <div v-if="fieldReport.field && fieldReport.field.address.name">{{ fieldReport.field.address.name }}</div>
                    {{ fieldReport.field ? fieldReport.field.address.text : '' }}
                  </td>
                  <td class="main">
                    <table style="width: 100%;">
                      <tr v-for="summary in fieldReport.summaries" v-bind:key="summary.key">
                        <td style="white-space: nowrap;">{{ summary.category ? summary.category.label : 'Mixed' }}</td>
                      </tr>
                    </table>
                  </td>
                  <td class="main" v-if="!produced">
                    <table style="width: 100%;">
                      <tr v-for="summary in fieldReport.summaries" v-bind:key="summary.key">
                        <td style="white-space: nowrap;">{{ summary.deadlineAsString }}</td>
                      </tr>
                    </table>
                  </td>
                  <td class="main" style="text-align: right; padding-right: 10px;">
                    <table style="width: 100%;">
                      <tr v-for="summary in fieldReport.summaries" v-bind:key="summary.key">
                        <td style="white-space: nowrap;">{{ summary.numberOfPallets }}</td>
                      </tr>
                    </table>
                  </td>
                  <td class="main" style="text-align: right; padding-right: 10px;">
                    <table style="width: 100%;">
                      <tr v-for="summary in fieldReport.summaries" v-bind:key="summary.key">
                        <td style="white-space: nowrap;">{{ produced ? summary.totalAmount : summary.totalPlannedAmount }}</td>
                      </tr>
                    </table>
                  </td>
                  <td class="main" style="text-align: right; padding-right: 10px;" v-if="produced">
                    <table style="width: 100%;">
                      <tr v-for="summary in fieldReport.summaries" v-bind:key="summary.key">
                        <td style="white-space: nowrap;">{{ summary.labelledAmount }}</td>
                      </tr>
                    </table>
                  </td>
                  <td class="main" style="text-align: right; padding-right: 10px;" v-if="produced">
                    <table style="width: 100%;">
                      <tr v-for="summary in fieldReport.summaries" v-bind:key="summary.key">
                        <td style="white-space: nowrap;">{{ summary.labelledAmount > 0 ? (Number(100 * summary.totalAmount / summary.labelledAmount).toFixed(0) + ' %') : '' }}</td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <tr v-bind:key="fieldReport.field.id + '_subtotal'" :class="(fieldReport.rowIndex % 2 === 0 ? 'even' : 'odd')">
                  <td :colspan="produced ? 3 : 4" style="text-align: left; padding-right: 10px;" class="subTotal"></td>
                  <td style="text-align: right; padding-right: 10px;" class="subTotal">{{ getTotalNumberOfPallets(fieldReport) }}</td>
                  <td style="text-align: right; padding-right: 10px;" class="subTotal">{{ getTotalAmount(fieldReport) }}</td>
                  <td style="text-align: right; padding-right: 10px;" class="subTotal" v-if="produced">{{ getTotalLabelledAmount(fieldReport) }}</td>
                  <td class="subTotal" v-if="produced"></td>
                </tr>
              </template>
            </template>
          </table>
          <table class="productionReport" v-if="sortedByDate">
            <tr>
              <th style="width: 130px;">{{ produced ? 'Produced' : 'Ready date' }}</th>
              <th v-if="produced" style="width: 75px; text-align: center;">Time</th>
              <th v-if="produced">By</th>
              <th>Shipment</th>
              <th v-if="produced">Pallet</th>
              <th>Category</th>
              <th style="text-align: right;" v-if="!produced">Pallets</th>
              <th style="text-align: right;" v-if="!produced">Per pallet</th>
              <th style="text-align: right;">Amount</th>
              <th>Supplier</th>
              <th>Field</th>
            </tr>
            <template v-for="(report) in productionReportByDate.dates">
              <tr v-for="(line) in report.lines" v-bind:key="line.key" :class="(report.rowIndex % 2 === 0 ? 'evenByDate' : 'oddByDate') + (((produced && report.firstInRow) || (!produced)) && line.lineIndex === 0 ? ' dateChanged' : '')">
                <td class="main">{{ report.date !== '0000-00-00 00:00' && report.date !== '9999-12-31 23:59' ? report.date : '' }}</td>
                <td class="main" style="text-align: right; padding-right: 25px; white-space: nowrap;" v-if="produced">{{ getProductionTime(line) }}</td>
                <td class="main" v-if="produced">{{ line.producedBy ? line.producedBy : '' }}</td>
                <td class="main">{{ line.shipmentNumber }}</td>
                <td class="main" v-if="produced">{{ line.palletNumber }}</td>
                <td class="main"><div v-html="line.categories"></div></td>
                <td class="main" style="text-align: right; padding-right: 15px;" v-if="!produced">{{ line.numberOfPallets }}</td>
                <td class="main" style="text-align: right; padding-right: 20px;" v-if="!produced">{{ line.plannedAmount !== 0 ? line.plannedAmount : '' }}</td>
                <td class="main" style="text-align: right; padding-right: 8px;"><div v-html="produced ? line.totalAmount : line.totalPlannedAmount"></div></td>
                <td class="main">{{ line.supplier.name }}</td>
                <td class="main">{{ line.field ? line.field.address && line.field.address.name && line.field.address.name != '' ? line.field.address.name : line.field.address ? line.field.address.text : '' : 'All fields' }}</td>
              </tr>
            </template>
          </table>
          <table class="productionReportContainer" v-if="inProductionSummary">
            <tr>
              <td style="padding-left: 5vw; padding-right: 30px;">
                <table class="productionReport">
                  <tr>
                    <th>Category</th>
                    <th style="text-align: right;">Amount</th>
                  </tr>
                  <tr v-for="(line, rowIndex) in productionReportSummary.categories" v-bind:key="line.category" :class="(rowIndex % 2 === 0 ? 'evenSummary' : 'oddSummary')">
                    <td class="main">{{ line.category }}</td>
                    <td class="main" style="text-align: right; padding-right: 8px;">{{ line.amount }}</td>
                  </tr>
                </table>
              </td>
              <td style="padding-left: 30px; padding-right: 5vw; width: 320px; padding-top: 25px;">
                <table class="productionReport">
                  <tr>
                    <td><v-label>Number of pallets</v-label></td>
                    <td style="text-align: right;"><v-label>{{ productionReportSummary.numberOfPallets }}</v-label></td>
                  </tr>
                  <tr>
                    <td><v-label>Total amount</v-label></td>
                    <td style="text-align: right;"><v-label>{{ productionReportSummary.totalAmount }}</v-label></td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
          <table class="productionReportContainer" v-if="inDeliveredShipments">
            <tr>
              <td style="padding: 20px;">
                <v-radio-group v-model="chosenShipment" class="shipmentListRadioGroup">
                  <table class="shipmentList">
                    <tr>
                      <th style="width: 50px;"></th>
                      <th>No</th>
                      <th>Loading date</th>
                      <th>Delivery date</th>
                      <th>Carrier</th>
                    </tr>
                      <tr v-for="(shipment, rowIndex) in deliveredShipments" v-bind:key="shipment.id" :class="(rowIndex % 2 === 0 ? 'evenSummary' : 'oddSummary')">
                        <td class="main" style="padding-left: 15px;"><v-radio :value="shipment" color="#004d40"></v-radio></td>
                        <td class="main">{{ shipment.number }}</td>
                        <td class="main">{{ shipment.pickupDate }}</td>
                        <td class="main">{{ shipment.deliveryDate }}</td>
                        <td class="main">{{ shipment.carrierName }}</td>
                      </tr>
                  </table>
                </v-radio-group>
              </td>
            </tr>
          </table>
        </v-flex>
      </v-layout>
    </v-container>
    <ErrorDialog ref="errorDialog"/>
  </v-flex>
</template>

<script>
import Panel from '../components/Panel'
import LoaderPallet from '../components/LoaderPallet'
import PanelColumn from '../components/PanelColumn'
import ErrorDialog from '../components/ErrorDialog'
import axios from 'axios'
import DateUtil from '@/assets/javascript/dateutil'
import uuid from 'uuid/v4'

export default {
  name: 'ProductionReport',
  components: { Panel, LoaderPallet, PanelColumn, ErrorDialog },
  data () {
    return {
      productionReport: null,
      shipments: null,
      productionReportByDate: null,
      productionReportSummary: null,
      productionReportLoaded: false,
      deliveredShipments: null,
      chosenShipment: null,
      mode: null,
      forLoader: true,
      produced: false,
      searchShipments: '',
      filterSuppliers: [],
      filterSupplier: { id: 0 },
      filterFields: [],
      filterField: { id: 0 },
      filterCategories: [],
      filterCategory: { id: 0 },
      filteredShipments: [],
      producedByUsers: null,
      filterProducedBy: null,
      printShipmentsUpdateCounter: 1,
      shipmentHeaders: [
        { text: 'No.', value: 'number', sortable: false },
        { text: 'Loading address', value: 'pickupAddresses', sortable: false },
        { text: 'Supplier', value: 'suppliers', sortable: false },
        { text: 'Field', value: 'fields', sortable: false },
        { text: 'Category', value: 'categories', sortable: false },
        { text: 'Pallets', value: 'pallets', align: 'right', sortable: false },
        { text: 'Pcs/plt', value: 'piecesPerPallet', align: 'right', sortable: false },
        { text: 'Status', value: 'status', align: 'center', sortable: false },
        { text: 'Total', value: 'total', align: 'right', sortable: false },
        { text: 'Ready date', value: 'contractorDate', sortable: false },
        { text: 'Carrier', value: 'carrierName', sortable: false },
        { text: 'Comments', value: 'comment', sortable: false }
      ],
      shipmentHeadersForLoader: [
        { text: 'No.', value: 'number', sortable: false },
        { text: 'Loading address', value: 'pickupAddresses', sortable: false },
        { text: 'Supplier', value: 'suppliers', sortable: false },
        { text: 'Field', value: 'fields', sortable: false },
        { text: 'Category', value: 'categories', sortable: false },
        { text: 'Pallets', value: 'pallets', align: 'right', sortable: false },
        { text: 'Pcs/plt', value: 'piecesPerPallet', align: 'right', sortable: false },
        { text: 'Status', value: 'status', align: 'center', sortable: false },
        { text: 'Total', value: 'total', align: 'right', sortable: false },
        { text: 'Ready date', value: 'contractorDate', sortable: false },
        { text: 'Loading date', value: 'pickupDate', sortable: false },
        { text: 'Carrier', value: 'carrierName', sortable: false },
        { text: 'Comments', value: 'comment', sortable: false }
      ],
      breadCrumbVisible: true,
      excelButtonVisible: true,
      pdfButtonVisible: true,
      padding: true
    }
  },
  created: function () {
    this.deSelectMode()
  },
  computed: {
    isModeSelected: function () {
      return this.mode !== null
    },
    inShipments: function () {
      return this.mode === 'SHIPMENTS'
    },
    inShipmentsForLoader: function () {
      return this.mode === 'SHIPMENTS_LOADER'
    },
    sortedByField: function () {
      return this.mode === 'BY_FIELD'
    },
    sortedByDate: function () {
      return this.mode === 'BY_DATE'
    },
    inProductionSummary: function () {
      return this.mode === 'SUMMARY'
    },
    inDeliveredShipments: function () {
      return this.mode === 'DELIVERED_SHIPMENTS'
    },
    buttonStyleFilterPlanned () {
      return (this.produced === false ? ' color: #606060 !important;' : '')
    },
    buttonStyleFilterProduced () {
      return (this.produced === true ? ' color: #606060 !important;' : '')
    },
    hasContractorRole: function () {
      return this.$store.getters['session/hasRole']('CONTRACTOR')
    },
    hasSupplierRole: function () {
      return this.$store.getters['session/hasRole']('SUPPLIER')
    },
    canPrintShipments: function () {
      let filteredItems = this.printShipmentsUpdateCounter && this.$refs.shipments ? this.$refs.shipments.filteredItems : null
      return !filteredItems || filteredItems.length > 0
    },
    showBreadCrumb: function () {
      return this.breadCrumbVisible
    },
    showExcelButton: function () {
      return this.excelButtonVisible
    },
    showPdfButton: function () {
      return this.pdfButtonVisible
    }
  },
  methods: {
    gotoFrontPage: function () {
      this.$parent.$parent.gotoHome()
    },
    hideBreadCrumb: function () {
      this.breadCrumbVisible = false
    },
    hideExcelButton: function () {
      this.excelButtonVisible = false
    },
    hidePdfButton: function () {
      this.pdfButtonVisible = false
    },
    loadShipments () {
      this.productionReportLoaded = false
      this.shipments = []
      let url = '/backend/rest/shipment/summary_for_production_overview?supplier=' + this.filterSupplier.id + '&field=' + (this.filterField ? this.filterField.id : 0) + '&category=' + (this.filterCategory ? this.filterCategory.id : 0) + (this.forLoader ? '&forLoader=true' : '')
      axios.get(url)
        .then(response => {
          this.shipments = response.data
          this.productionReportLoaded = true
        })
    },
    loadProductionReport () {
      if (this.sortedByField) {
        this.loadProductionReportByField()
      } else {
        this.loadProductionReportByDate()
      }
    },
    loadProductionReportByField () {
      this.productionReportLoaded = false
      axios.get('/backend/rest/production_report/by_field?produced=' + this.produced)
        .then(response => {
          this.productionReport = response.data
          this.productionReportLoaded = true
        })
    },
    loadProductionReportByDate () {
      this.productionReportLoaded = false
      let url = '/backend/rest/production_report/by_date?produced=' + this.produced
      if (this.produced && this.filterProducedBy && this.filterProducedBy !== '') {
        url += '&userName=' + this.filterProducedBy
      }
      axios.get(url)
        .then(response => {
          this.productionReportByDate = response.data
          if (!this.producedByUsers && this.productionReportByDate && this.productionReportByDate.dates && this.productionReportByDate.dates.length) {
            this.producedByUsers = []
            this.producedByUsers.push({
              id: null,
              name: ''
            })
            for (let date of this.productionReportByDate.dates) {
              if (date.lines && date.lines.length) {
                for (let line of date.lines) {
                  if (line.producedById !== null && line.producedBy && line.producedBy !== '' && !this.producedByUsers.filter(u => u.id === line.producedById).length) {
                    this.producedByUsers.push({
                      id: line.producedById,
                      name: line.producedBy
                    })
                  }
                }
              }
            }
            this.producedByUsers.sort(function (pb1, pb2) {
              return pb1.name.localeCompare(pb2.name)
            })
          }
          this.productionReportLoaded = true
        })
    },
    loadProductionReportSummary () {
      this.productionReportLoaded = false
      axios.get('/backend/rest/production_report/summary')
        .then(response => {
          this.productionReportSummary = response.data
          this.productionReportLoaded = true
        })
    },
    loadDeliveredShipments () {
      this.productionReportLoaded = false
      axios.get('/backend/rest/shipment/contractor/delivered')
        .then(response => {
          this.deliveredShipments = response.data
          this.productionReportLoaded = true
        })
    },
    loadFilterSuppliers () {
      axios.get('/backend/rest/supplier/production_overview')
        .then(response => {
          this.filterSuppliers = response.data
          this.filterSuppliers.splice(0, 0, {
            id: 0,
            name: ''
          })
        })
    },
    loadFilterFields () {
      axios.get('/backend/rest/field/production_overview')
        .then(response => {
          this.filterFields = response.data
          this.filterFields.splice(0, 0, {
            id: 0,
            address: {
              nameAndText: ''
            }
          })
        })
    },
    loadFilterCategories () {
      axios.get('/backend/rest/category/production_overview')
        .then(response => {
          this.filterCategories = response.data
          this.filterCategories.splice(0, 0, {
            id: 0,
            displayLabel: ''
          })
        })
    },
    formatDatetime (date) {
      return DateUtil.datetimeToString(date)
    },
    categories: function (pallet) {
      let categories = ''
      if (pallet.items) {
        let items = pallet.items
        for (let item of items) {
          if (categories.length > 0) {
            categories += '<br/>'
          }
          categories += (item.category ? item.category.label : item.categoryName)
          categories += ', ' + item.plannedAmount + 'pcs.'
        }
      }
      return categories
    },
    goShipments () {
      this.mode = 'SHIPMENTS'
      this.forLoader = false
      this.loadShipments()
      this.loadFilterSuppliers()
      this.loadFilterFields()
      this.loadFilterCategories()
    },
    goShipmentsForLoader () {
      this.mode = 'SHIPMENTS_LOADER'
      this.forLoader = true
      this.loadShipments()
      this.loadFilterSuppliers()
      this.loadFilterFields()
      this.loadFilterCategories()
    },
    setPadding (padding) {
      this.padding = padding
    },
    sortByField () {
      this.mode = 'BY_FIELD'
      this.produced = false
      this.loadProductionReportByField()
    },
    sortByDate () {
      this.mode = 'BY_DATE'
      this.produced = true
      this.loadProductionReportByDate()
    },
    productionSummary () {
      this.mode = 'SUMMARY'
      this.loadProductionReportSummary()
    },
    goDeliveredShipments () {
      this.mode = 'DELIVERED_SHIPMENTS'
      this.chosenShipment = null
      this.loadDeliveredShipments()
    },
    deSelectMode () {
      this.mode = null
    },
    toggleFilterProduced (produced) {
      this.produced = produced
      this.loadProductionReport()
    },
    printReport () {
      let url = ''
      if (this.inDeliveredShipments) {
        url = '/backend/print/deliveryNote.xhtml?shipmentId=' + this.chosenShipment.id + '&details=true&title=Delivery Note'
      } else {
        if (this.sortedByField) {
          url = '/backend/print/contractorProductionReport.xhtml'
        } else {
          url = '/backend/print/contractorProductionReportByDate.xhtml'
        }
        url += '?produced=' + this.produced
        if (!this.sortedByField && this.produced && this.filterProducedBy && this.filterProducedBy !== '') {
          url += '&userName=' + this.filterProducedBy
        }
      }
      window.open(url)
    },
    printShipments (forLoader = false) {
      let filteredItems = this.$refs.shipments.filteredItems
      let shipmentIds = []
      for (let shipment of filteredItems) {
        shipmentIds.push(shipment.id)
      }
      let params = 'shipments=' + shipmentIds.join(',')
      params += '&supplier=' + this.filterSupplier.id
      params += '&field=' + this.filterField.id
      params += '&category=' + this.filterCategory.id
      params += '&forLoader=' + forLoader
      axios.post('/backend/print/shipmentsForProductionOverview.xhtml', params, {responseType: 'blob'})
        .then((response) => {
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(new Blob([response.data], { type: 'application/pdf' }), 'Shipments.pdf')
          } else {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'Shipments.pdf')
            document.body.appendChild(link)
            link.click()
          }
        })
    },
    excelReport () {
      let url = ''
      if (this.inDeliveredShipments) {
        url = '/backend/print/deliveryNote.xhtml?shipmentId=' + this.chosenShipment.id + '&details=true&title=Delivery Note'
      } else {
        if (this.sortedByField) {
          url = '/backend/report/productionReport/byField'
        } else {
          url = '/backend/report/productionReport/byDate'
        }
        url += '?produced=' + this.produced
        if (!this.sortedByField && this.produced && this.filterProducedBy && this.filterProducedBy !== '') {
          url += '&userName=' + this.filterProducedBy
        }
        url += '&uuid=' + uuid()
      }
      window.open(url)
    },
    excelShipments (forLoader = false) {
      let filteredItems = this.$refs.shipments.filteredItems
      let shipmentIds = []
      for (let shipment of filteredItems) {
        shipmentIds.push(shipment.id)
      }
      let params = 'shipments=' + shipmentIds.join(',')
      params += '&supplier=' + this.filterSupplier.id
      params += '&field=' + this.filterField.id
      params += '&category=' + this.filterCategory.id
      params += '&forLoader=' + forLoader
      axios.post('/backend/report/shipmentsForProductionOverview', params, {responseType: 'blob'})
        .then((response) => {
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(new Blob([response.data], { type: 'application/vnd.ms-excel' }), 'Shipments.xlsx')
          } else {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.ms-excel' }))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'Shipments.xlsx')
            document.body.appendChild(link)
            link.click()
          }
        })
    },
    getTotalNumberOfPallets (fieldReport) {
      let total = 0
      if (fieldReport.summaries) {
        for (let summary of fieldReport.summaries) {
          total += summary.numberOfPallets
        }
      }
      return total
    },
    getTotalAmount (fieldReport) {
      let total = 0
      if (fieldReport.summaries) {
        for (let summary of fieldReport.summaries) {
          let totalAmount = this.produced ? summary.totalAmount : summary.totalPlannedAmount
          total += totalAmount
        }
      }
      return total
    },
    getTotalLabelledAmount (fieldReport) {
      let total = 0
      if (fieldReport.summaries) {
        for (let summary of fieldReport.summaries) {
          total += summary.labelledAmount
        }
      }
      return total
    },
    getProductionTime (line) {
      let result = ''
      if (line && line.productionTime && line.productionTime > 0) {
        let time = line.productionTime
        let hours = 0
        let minutes = 0
        if (time > 60) {
          hours = Math.floor(time / 60)
          time -= hours * 60
          result += hours + ' hour' + (hours > 1 ? 's' : '')
        }
        if (time > 0) {
          minutes = time
          if (result !== '') {
            result += ', '
          }
          result += minutes + ' min'
        }
      }
      return result
    },
    displayDate (date) {
      if (date && date.endsWith(' 00:00')) {
        return date.substring(0, date.lastIndexOf(' 00:00'))
      }
      return date
    },
    displayNumberOfPallets (numberOfPallets) {
      if (numberOfPallets) {
        numberOfPallets = numberOfPallets.replace(/\*/g, '')
      }
      return numberOfPallets
    }
  },
  watch: {
    searchShipments (val) {
      this.printShipmentsUpdateCounter++
    }
  }
}
</script>

<style scoped>
  button {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .v-btn {
    border-radius: 12px;
  }
  .v-btn .v-btn__content {
  }
  table.productionReportContainer {
    width: 100%;
    border-collapse: collapse;
  }
  table.productionReportContainer td {
    vertical-align: top;
  }
  table.productionReport {
    width: 100%;
    border-collapse: collapse;
    padding-left: 10px;
    padding-right: 10px;
  }
  table.productionReport th {
    text-align: left;
    border-bottom: 1px solid #004d40;
    padding: 2px 5px;
  }
  table.productionReport td.main {
    vertical-align: top;
    border-bottom: 0.5px solid #D0D0D0;
    padding: 2px 5px;
  }
  table.productionReport td.subTotal {
    vertical-align: top;
    border-bottom: 1px solid #D0D0D0;
    padding: 2px 12px 10px 5px !important;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.54);
  }
  tr.odd {
    background-color: #ffffff;
  }
  tr.even {
    background-color: rgba(0, 77, 64, 0.02);
  }
  tr.oddByDate {
    background-color: rgba(0, 77, 64, 0.02);
  }
  tr.evenByDate {
    background-color: #ffffff;
  }
  tr.oddSummary {
    background-color: rgba(0, 77, 64, 0.02);
  }
  tr.evenSummary {
    background-color: #ffffff;
  }
  tr.oddShipment {
    background-color: rgba(0, 77, 64, 0.02);
  }
  tr.evenShipment {
    background-color: #ffffff;
  }
  tr.dateChanged {
    border-top: 2px solid #303030 !important;
  }
  div.shipmentTable .v-table tr td {
    font-size: 13px !important;
  }
  table.shipmentList {
    border-collapse: collapse;
  }
  table.shipmentList th {
    text-align: left;
    border-bottom: 1px solid #004d40;
    padding: 2px 5px;
  }
  table.shipmentList td {
    text-align: left;
    padding: 4px 5px;
    vertical-align: middle;
    border-bottom: 1px solid #D0D0D0;
  }
  div.noShipments {
    width: 100%;
    text-align: center;
    padding-top: 20vh;
    font-size: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ProductionReport.vue